import { Box, Button, SxProps, Theme } from '@mui/material';

import { ChevronLeftOutline, ChevronRightOutline } from '../../../icons';

// Prev/next controls shared by every module pricing landing's demo carousel.
// Hidden via opacity rather than disabled: at the first/last step the
// inactive button keeps its layout space instead of collapsing it.
const customStyles = {
  container: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'space-between',
  },
  hidden: {
    opacity: 0,
    pointerEvents: 'none',
  },
} satisfies Record<string, SxProps<Theme>>;

interface Props {
  activeIndex: 0 | 1;
  onChangeIndex: (index: 0 | 1) => void;
  previousLabel: string;
  nextLabel: string;
  // The two current landings differ slightly here (16px vs 10px) -- a plain
  // string keeps this a narrow, type-safe override instead of accepting an
  // arbitrary SxProps that would fight the array-form composition above.
  marginTop: string;
}

export function DemoCarouselNavButtons({
  activeIndex,
  onChangeIndex,
  previousLabel,
  nextLabel,
  marginTop,
}: Props) {
  return (
    <Box sx={[customStyles.container, { marginTop }]}>
      <Button
        color='primary'
        startIcon={<ChevronLeftOutline />}
        onClick={() => onChangeIndex(0)}
        sx={activeIndex === 1 ? undefined : customStyles.hidden}
        data-testid='prev'
      >
        {previousLabel}
      </Button>
      <Button
        color='primary'
        endIcon={<ChevronRightOutline />}
        onClick={() => onChangeIndex(1)}
        sx={activeIndex === 0 ? undefined : customStyles.hidden}
        data-testid='next'
      >
        {nextLabel}
      </Button>
    </Box>
  );
}
